export const MediaSidebarData = [
        {
        title: "About Us",
        icon: "bi-question-circle-fill",
         path:"/about"
    },
   
    {
        title: "Courses",
        icon: "bi-question-circle-fill",
         path:"/courses"
    },

    {
        title: "Events",
        icon: "bi-question-circle-fill",
        path:"/events"
    },


    {
        title: "FAQ",
        icon: "bi-question-circle-fill",
        
    },
    {
        title: "Contact Us",
        icon: "bi-question-circle-fill",
         path:"/contact"
    },
 
]
